const LogOutIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1665 3.33366C3.94549 3.33366 3.73353 3.42146 3.57725 3.57774C3.42097 3.73402 3.33317 3.94598 3.33317 4.16699V15.8337C3.33317 16.0547 3.42097 16.2666 3.57725 16.4229C3.73353 16.5792 3.94549 16.667 4.1665 16.667H7.49984C7.96007 16.667 8.33317 17.0401 8.33317 17.5003C8.33317 17.9606 7.96007 18.3337 7.49984 18.3337H4.1665C3.50346 18.3337 2.86758 18.0703 2.39874 17.6014C1.9299 17.1326 1.6665 16.4967 1.6665 15.8337V4.16699C1.6665 3.50395 1.9299 2.86807 2.39874 2.39923C2.86758 1.93038 3.50346 1.66699 4.1665 1.66699H7.49984C7.96007 1.66699 8.33317 2.04009 8.33317 2.50033C8.33317 2.96056 7.96007 3.33366 7.49984 3.33366H4.1665Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7441 5.24408C13.0695 4.91864 13.5972 4.91864 13.9226 5.24408L18.0893 9.41074C18.4147 9.73618 18.4147 10.2638 18.0893 10.5893L13.9226 14.7559C13.5972 15.0814 13.0695 15.0814 12.7441 14.7559C12.4186 14.4305 12.4186 13.9028 12.7441 13.5774L16.3215 10L12.7441 6.42259C12.4186 6.09715 12.4186 5.56951 12.7441 5.24408Z"
        fill="#857F8B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6665 10.0003C6.6665 9.54009 7.0396 9.16699 7.49984 9.16699H17.4998C17.9601 9.16699 18.3332 9.54009 18.3332 10.0003C18.3332 10.4606 17.9601 10.8337 17.4998 10.8337H7.49984C7.0396 10.8337 6.6665 10.4606 6.6665 10.0003Z"
        fill="#857F8B"
      />
    </svg>
  );
};

export default LogOutIcon;
